import { useAuth } from '../contexts/AuthContext'
import { brandScope, type BrandScope } from '../utils/scope'

/**
 * React-Zugriff auf das zentrale brand-admin-Scoping: dünner `useAuth()`-Wrapper
 * um die reine Funktion `brandScope()` aus `utils/scope.ts`.
 */
export function useBrandScope(): BrandScope {
  const { session } = useAuth()
  return brandScope(session)
}
